import { Component, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexXAxis,
  ApexFill,
  ApexStroke,
  ApexGrid,
  ApexAnnotations,
  ApexLegend,
  ApexTitleSubtitle,
  ChartComponent,
  ApexResponsive,
  ApexTooltip
} from 'ng-apexcharts';
import { /* debounceTime, distinctUntilChanged, map, */ Observable, Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { generateCertificatControl, getStat, getAllCertificatControl } from 'src/app/store/actions/certificatControl.action';
import { CertificatControlState } from 'src/app/store/reducers/certificatControl.reducer';
import { InspectionState } from 'src/app/store/reducers/inspection.reducer';
import { selectAllCertificatControls } from 'src/app/store/selector/certificatControl.selector';
import { selectAllInspections } from 'src/app/store/selector/inspection.selector';
import { BadgeState } from 'src/app/store/reducers/badge.reducer';
import { selectAllBadges } from 'src/app/store/selector/badge.selector';

export type PieChartOptions = {
  series: number[];
  chart: ApexChart;
  labels: string[];
  responsive: ApexResponsive[];
  colors: string[];
  legend?: ApexLegend;
  dataLabels?: ApexDataLabels;
};

export type BarChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  stroke: ApexStroke;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

export type LineChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  grid: ApexGrid;
  title: ApexTitleSubtitle;
};

export type LineChartOptions2 = {
  series: any[];
  chart: any;
  xaxis: any;
  yaxis: any;
  stroke: any;
  markers: any;
  dataLabels: any;
  colors: string[];
  grid: any;
  legend: any;
  tooltip: any;
}

export type HistChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: any; //ApexXAxis;
  annotations: ApexAnnotations;
  fill: ApexFill;
  stroke: ApexStroke;
  grid: ApexGrid;
};


export interface InspectionSocieteChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  fill?: ApexFill;
  grid: ApexGrid;
  stroke?: ApexStroke;
  legend: ApexLegend;
  colors: string[];
  title?: ApexTitleSubtitle;
}

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  stroke: ApexStroke;
  grid: ApexGrid;
  annotations: ApexAnnotations;
  colors: string[];
  legend: ApexLegend;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  inpectionsVehicule$: Observable<any>;
  public chartOptions!: Partial<HistChartOptions>;
  @ViewChild("chart") chart!: ChartComponent;
  public statusChart!: Partial<BarChartOptions>;
  badges$: Observable<any>;
  public trendChart!: Partial<LineChartOptions>;
  public lineChart!: Partial<LineChartOptions2>;
  public vehicleTypeChart!: Partial<PieChartOptions>;
  public inspectionSocieteChart!: Partial<InspectionSocieteChartOptions>;
  searchDate = ''
  paginatedInspections: any[] = [];
  badges = 0; // Initialisé à 0, sera chargé depuis le backend
  certificatControls = 0; // Initialisé à 0, sera chargé depuis le backend
  certificatControlsTab: any[] = [];
  totalBadgesActive = 0; // Initialisé à 0, sera chargé depuis le backend
  complianceRate = 0; // Initialisé à 0, sera chargé depuis le backend
  subscription!: Subscription;
  dateSubscription!: Subscription;
  statusSubscription!: Subscription;
  inputSubject = new Subject<string>();
  dateInputSubject = new Subject<string>();
  statusSubject = new Subject<string>();
  dateDebut: string = '';
  selectedInspections: number[] = [];
  dateFin: string = '';
  selectedSociete: string = '';
  selectedStatut: string = '';
  searchTerm: string = '';
  selectedStatus = -1
  societes: string[] = []; // Sera chargé depuis les données réelles

  filteredInspections: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  showExportDropdown: boolean = false;
  // Les données seront chargées depuis le backend via applyFilters()
  // Plus de données d'exemple en dur
  trendMultiLine: any[] = [];
  inpections$: Observable<ReadonlyArray<any>>;
  constructor(private store: Store<any>, private dataService: DataService, private storeBadge: Store<BadgeState>) {
    this.chartOptions = {
      series: [
        {
          name: "Cartes créés",
          data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65]
        }
      ],
      annotations: {
        points: [
          {
            x: "xaxis",
            seriesIndex: 0,
            label: {
              borderColor: "#775DD0",
              offsetY: 0,
              style: {
                color: "#fff",
                background: "#775DD0"
              },
              text: "yaxis"
            }
          }
        ]
      },
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          //endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2
      },

      // grid: {
      //   row: {
      //     colors: ["#1f2937cc", "#1f2937cc"]
      //   }
      // },
      xaxis: {
        labels: {
          rotate: -45,
          style: {
            colors: '#1f2937'
          }
        },
        categories: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Decembre",

        ],
        tickPlacement: "on",

      },
      yaxis: {
        title: {
          text: "Cartes créés",
          style: {
            color: "#1f2937"
          }
        },
        labels: {
          style: {
            colors: "#1f2937"
          }
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100]
        }
      }
    };
    this.inpectionsVehicule$ = this.store.pipe(select(selectAllCertificatControls))
    this.badges$ = this.storeBadge.pipe(select(selectAllBadges))
    // Initialisation des graphiques
    this.initStatusChart();
    this.initTrendChart();
    this.initVehicleTypeChart();
    this.initLineChart();
    this.initInspectionSocieteChart();
    this.inpections$ = this.store.pipe(select(selectAllInspections))
  }
  inspections: any[] = [];
  selectedInspection = 0
  moisOptions = [
    { value: 'UN_MOIS', label: '1 MOIS' },
    { value: 'DEUX_MOIS', label: '2 MOIS' },
    { value: 'TROIS_MOIS', label: '3 MOIS' },
    { value: 'QUATRE_MOIS', label: '4 MOIS' },
    { value: 'CINQ_MOIS', label: '5 MOIS' },
    { value: 'SIX_MOIS', label: '6 MOIS' },
    { value: 'SEPT_MOIS', label: '7 MOIS' },
    { value: 'HUIT_MOIS', label: '8 MOIS' },
    { value: 'NEUF_MOIS', label: '9 MOIS' },
    { value: 'DIX_MOIS', label: '10 MOIS' },
    { value: 'ONZE_MOIS', label: '11 MOIS' },
    { value: 'DOUZE_MOIS', label: '12 MOIS' },
    { value: 'TREIZE_MOIS', label: '13 MOIS' },
    { value: 'QUATORZE_MOIS', label: '14 MOIS' },
    { value: 'QUINZE_MOIS', label: '15 MOIS' },
    { value: 'SEIZE_MOIS', label: '16 MOIS' },
    { value: 'DIX_SEPT_MOIS', label: '17 MOIS' },
    { value: 'DIX_HUIT_MOIS', label: '18 MOIS' },
    { value: 'DIX_NEUF_MOIS', label: '19 MOIS' },
    { value: 'VINGT_MOIS', label: '20 MOIS' }
  ];
  badgesArray: any[] = [];
  ngOnInit(): void {

    const today = new Date();

    // Date de début = un mois en arrière
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 12);

    // Formater en LocalDate (yyyy-MM-dd)
    function formatDate(date: Date): string {
      return date.toISOString().split('T')[0];
    }

    this.dateFin = formatDate(today);
    this.dateDebut = formatDate(lastMonth);
    this.selectedInspection = -1

    // Charger les inspections pour le filtre
    this.inpections$.subscribe((inspections: any) => {
      console.log(inspections.inspections)
      if (Array.isArray(inspections.inspections) && inspections.inspections.length > 0) {
        this.inspections = inspections.inspections
        this.inspections = this.inspections.filter(inspection => inspection.nom !== "OPRAG" && inspection.nom !== "CIMFEP");
      } else {
        console.log('No inspections found or still loading.');
      }
    });

    // ✅ SIMPLIFICATION: Plus besoin de NgRx, on utilise directement le service
    // Charger la première page de données
    this.loadCertificatControls(0, this.itemsPerPage);

    // Charger les statistiques indépendamment (pas de pagination pour les stats)
    this.applyFilters();

    this.badges$.subscribe((badges: any) => {
      if (Array.isArray(badges.badges.content) && badges.badges.content.length > 0) {
        console.log("charts objects: ", badges.chartsObjects)
        this.badgesArray = badges.badges.content
        const counts = badges.chartsObjects.slice(-20).map((item: any) => item.count);
        const dates = badges.chartsObjects.slice(-20).map((item: any) => item.date);

        this.chartOptions = {
          ...this.chartOptions,
          series: [
            {
              name: "Badges Créés",
              data: counts
            }
          ],
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: dates,
            labels: {
              rotate: -45,
              // style: {
              //   colors: '#ffffff'
              // }
            }
          }
        };

        this.totalBadgesActive = this.badgesArray.reduce((count: any, badge: any) => badge.active === true ? count + 1 : count, 0)

      } else {
        console.log('No badges found or still loading.');
      }
    });
    this.badges$.subscribe((badges: any) => {
      if (Array.isArray(badges.badges.content) && badges.badges.length > 0) {
        const counts = badges.chartsObjectsByDates.map((item: any) => item.count);
        const dates = badges.chartsObjectsByDates.map((item: any) => item.date);

        this.chartOptions = {
          ...this.chartOptions,
          series: [
            {
              name: "Badges Créé",
              data: counts
            }
          ],
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: dates,
            labels: {
              rotate: -45,
              style: {
                colors: '#ffffff'
              }
            }
          }
        };

        this.totalBadgesActive = this.badgesArray.reduce((count: any, badge: any) => badge.active === true ? count + 1 : count, 0)

      } else {
        console.log('No badges found or still loading.');
      }
    });
  }

  loadCertificatControls(page: number, size: number): void {
    console.log(`🚀 Loading CertificatControls - Page: ${page}, Size: ${size}`);

    // Appel direct au service sans NgRx
    this.dataService.loadData("CertificatControls", page, size).subscribe({
      next: (response: any) => {
        console.log('✅ CertificatControls loaded:', response);

        if (response && response.content) {
          // Mapper les données avec les labels de validité
          const newData = response.content.map((ctrl: any) => {
            const option = this.moisOptions.find(opt => opt.value === ctrl.validite);
            return {
              ...ctrl,
              validite: option ? option.label : ctrl.validite
            };
          });

          this.paginatedInspections = newData;
          this.totalItems = response.totalElements || 0;
          this.currentPage = (response.pageable?.pageNumber || 0) + 1;
          this.certificatControlsTab = newData;
          this.tableDataLoaded = true;
          this.checkAllDataLoaded();

          console.log(`📊 Dashboard Pagination - Page: ${this.currentPage}/${this.totalPages}, Total: ${this.totalItems} items`);
        }
      },
      error: (error) => {
        console.error('❌ Error loading CertificatControls:', error);
        this.paginatedInspections = [];
        this.totalItems = 0;
        this.tableDataLoaded = true;
        this.checkAllDataLoaded();
      }
    });
  }

  initInspectionSocieteChart(): void {
    const inspectionData = { series: [25, 74, 45, 63, 12], labels: ["Transports ABC", "Logistique XYZ", "Camions 123", "Fret Ouest", "Transporteurs Associés"] };

    this.inspectionSocieteChart = {
      series: [{
        name: 'Nombre d\'inspections',
        data: inspectionData.series
      }],
      chart: {
        type: 'bar',
        height: 500,
        stacked: false,
        toolbar: {
          show: true
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%',
          borderRadius: 4,
          dataLabels: {
            position: 'top'
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => {
          return val.toString();
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#304758']
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: inspectionData.labels,
        title: {
          text: '',

        },
        labels: {
          style: {
            fontSize: '11px'
          },
        }
      },
      yaxis: {
        title: {
          text: "Nombre d'inspections"
        },
        labels: {
          formatter: (val: number) => {
            return Math.round(val).toString();
          }
        }
      },
      fill: {
        opacity: 1
      },
      colors: ['#008FFB'],
      legend: {
        position: 'top',
        horizontalAlign: 'center',
      },
      tooltip: {
        y: {
          formatter: (val: number) => {
            return val + " inspection(s)";
          }
        }
      },
      grid: {
        borderColor: '#f1f1f1',
        row: {
          colors: ['transparent', '#f8f8f8'],
          opacity: 0.5
        }
      }
    };
  }


  // Vérifie si une inspection est sélectionnée
  isSelected(inspectionId: number): boolean {
    return this.selectedInspections.includes(inspectionId);
  }

  // Vérifie si toutes les inspections de la page sont sélectionnées
  isAllSelected(): boolean {
    if (this.paginatedInspections.length === 0) return false;
    return this.paginatedInspections.every(inspection =>
      this.selectedInspections.includes(inspection.id)
    );
  }

  toggleInspectionSelection(inspectionId: number): void {
    const index = this.selectedInspections.indexOf(inspectionId);
    if (index > -1) {
      this.selectedInspections.splice(index, 1);
    } else {
      this.selectedInspections.push(inspectionId);
    }
  }

  toggleSelectAll(event: any): void {
    if (event.target.checked) {
      this.paginatedInspections.forEach(inspection => {
        if (!this.selectedInspections.includes(inspection.id)) {
          this.selectedInspections.push(inspection.id);
        }
      });
    } else {
      this.paginatedInspections.forEach(inspection => {
        const index = this.selectedInspections.indexOf(inspection.id);
        if (index > -1) {
          this.selectedInspections.splice(index, 1);
        }
      });
    }
  }

  downloadSelectedInspections(): void {
    if (this.selectedInspections.length === 0) return;


    this.selectedInspections.forEach(inspectionId => {
      this.generateReportAction(inspectionId);
    });


    this.selectedInspections = [];
  }

  onInputChange(event: any) {
    this.inputSubject.next(event.target.value);
  }
  onDateInputChange(event: any) {
    this.dateInputSubject.next(event.target.value);
  }

  onStatusChange(event: any) {
    this.statusSubject.next(event.target.value);
  }

  updatePaginatedInspections(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = this.currentPage * this.itemsPerPage;
    this.paginatedInspections = this.filteredInspections.slice(start, end);
  }


  initStatusChart(): void {
    this.statusChart = {
      series: [{
        name: 'Conformes',
        data: [45, 52, 38, 45, 49, 43, 40, 52, 38, 45, 49, 43, 40, 45]
      }, {
        name: 'Non conformes',
        data: [12, 8, 15, 10, 7, 9, 12, 8, 15, 10, 7, 9, 12, 8]
      }],
      chart: {
        type: 'bar',
        height: 350,
        stacked: false
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['01/09', '02/09', '03/09', '04/09', '05/09', '06/09', '07/09', '08/09', '09/09', '10/09', '11/09', '12/09', '13/09', '14/09'],
        title: {
          text: 'Date'
        }
      },
      yaxis: {
        title: {
          text: "Nombre d'inspections"
        }
      },
      fill: {
        opacity: 1
      },
      colors: ['#4CAF50', '#F44336'],
      legend: {
        position: 'top',
        horizontalAlign: 'center',
      }
    };
  }

  initTrendChart(): void {
    this.trendChart = {
      series: [{
        name: "Inspections",
        data: [57, 60, 53, 55, 56, 52, 60, 60, 53, 56, 56, 55, 52, 53]
      }],
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      title: {
        text: 'Tendances des inspections par jour',
        align: 'left'
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5
        },
      },
      xaxis: {
        categories: ['01/09', '02/09', '03/09', '04/09', '05/09', '06/09', '07/09', '08/09', '09/09', '10/09', '11/09', '12/09', '13/09', '14/09'],
        title: {
          text: 'Date'
        }
      },
      yaxis: {
        title: {
          text: "Nombre d'inspections"
        }
      }
    };
  }

  initVehicleTypeChart(): void {
    this.vehicleTypeChart = {
      series: [44, 55, 13, 43, 22],
      chart: {
        width: 480,
        type: 'pie',
      },
      labels: ['Camions frigorifiques', 'Porte-conteneurs', 'Camions-citernes', 'Plateaux', 'Autres'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    };
  }

  getReportsTrendData(): { series: any[], categories: string[] } {
    // Retourner les données réelles du backend au lieu des données d'exemple
    // Les données sont maintenant dans trendMultiLine
    if (this.trendMultiLine && this.trendMultiLine.length > 0) {
      return this.transformTrendData(this.trendMultiLine);
    }
    // Retourner des données vides si pas encore chargées
    return {
      series: [],
      categories: []
    };
  }

  initLineChart(): void {
    // Récupérer les données réelles de votre base
    const chartData = this.transformTrendData(this.trendMultiLine);

    this.lineChart = {
      series: chartData.series,
      chart: {
        type: 'line',
        height: 350,
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        }
      },
      stroke: {
        curve: 'smooth',
        width: 3
      },
      markers: {
        size: 5,
        hover: {
          size: 7
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: chartData.categories,
        title: {
          text: 'Date'
        },
        labels: {
          rotate: -45
        }
      },
      yaxis: {
        title: {
          text: 'Nombre de rapports'
        },
        min: 0,
        labels: {
          formatter: (value: number) => {
            return `${Math.round(value)}`; // Pas de pourcentage, juste le nombre
          }
        }
      },
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9', '#FF66C3'],
      grid: {
        borderColor: '#f1f1f1',
        row: {
          colors: ['transparent', '#f8f8f8'],
          opacity: 0.5
        }
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
        offsetY: 0
      },
      tooltip: {
        y: {
          formatter: (value: number) => {
            return `${value} rapports`;
          }
        }
      }
    };
  }

  formatDates(dates: string[]): string[] {
    return dates.map(dateString => {
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit'
        });
      } catch (error) {
        console.error(`Erreur de formatage de la date: ${dateString}`, error);
        return dateString;
      }
    });
  }
  transformTrendData(trendMultiLine: any[]): any {
    if (!trendMultiLine || trendMultiLine.length === 0) {
      return { series: [], categories: [] };
    }

    // Regrouper les données par partenaire
    const partnersData = new Map<string, Map<string, number>>();
    const allDates = new Set<string>();

    // Organiser les données
    trendMultiLine.forEach(item => {
      const partnerName = item.NomInspection || 'Non spécifié';
      const date = item.date;
      const count = item.count || 0;

      if (!partnersData.has(partnerName)) {
        partnersData.set(partnerName, new Map<string, number>());
      }

      partnersData.get(partnerName)!.set(date, count);
      allDates.add(date);
    });

    // Convertir les dates en tableau et les trier
    const sortedDates = Array.from(allDates).sort((a, b) =>
      new Date(a).getTime() - new Date(b).getTime()
    );

    // Formater les dates pour l'affichage
    const formatDate = (dateString: string): string => {
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit'
        });
      } catch {
        return dateString;
      }
    };

    const categories = sortedDates.map(formatDate);

    // Créer les séries pour chaque partenaire
    const series = Array.from(partnersData.entries()).map(([partnerName, dateCounts]) => {
      const data = sortedDates.map(date => {
        return dateCounts.get(date) || 0;
      });

      return {
        name: partnerName,
        data: data
      };
    });

    return {
      series: series,
      categories: categories
    };
  }
  updateChartWithData(newData: any[]): void {
    this.trendMultiLine = newData;
    this.initLineChart();
  }
  getLastWeekDays(): string[] {
    const days = [];
    const dayNames = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

    // Aujourd'hui
    const today = new Date();

    // Générer les 7 derniers jours (du plus ancien au plus récent)
    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      const dayName = dayNames[date.getDay()];
      const dayNumber = date.getDate();
      const month = date.getMonth() + 1;
      days.push(`${dayName} ${dayNumber}/${month}`);
    }

    return days;
  }




  // Mettre à jour les données du graphique
  updateChartData(series: any[], categories: string[]): void {
    if (this.lineChart) {
      this.lineChart.series = series;
      this.lineChart.xaxis = {
        ...this.lineChart.xaxis,
        categories: categories
      };
    }
  }

  searchDataPerDate(): void {
    // Option 3: Recharger les statistiques ET le tableau avec les nouvelles dates
    // Réinitialiser les flags de chargement
    this.dataLoaded = false;
    this.tableDataLoaded = false;
    this.statsDataLoaded = false;

    this.applyFilters(); // Charge uniquement les statistiques
    // Recharger aussi la première page du tableau avec les nouvelles dates
    this.currentPage = 1;
    this.loadCertificatControls(0, this.itemsPerPage);
  }

  dataLoaded: boolean = false;
  tableDataLoaded: boolean = false; // Flag pour les données du tableau
  statsDataLoaded: boolean = false; // Flag pour les statistiques

  // Méthode pour vérifier si tout est chargé (INITIAL LOAD seulement)
  checkAllDataLoaded(): void {
    // Pour le chargement initial, attendre les deux
    // Pour la pagination, tableDataLoaded suffit
    if (this.tableDataLoaded && this.statsDataLoaded) {
      this.dataLoaded = true;
      console.log('✅ Chargement initial complet');
    } else if (this.tableDataLoaded && this.dataLoaded) {
      // Lors de la pagination, si déjà chargé une fois, rester chargé
      console.log('✅ Données de tableau mises à jour (pagination)');
    }
  }

  applyFilters(): void {
    // Option 3: Les statistiques sont chargées indépendamment
    // Ne PAS toucher aux données du tableau qui sont gérées par pagination serveur
    if (this.selectedInspection == -1) {
      this.dataService.getStatWithoutInspection(this.dateDebut, this.dateFin).subscribe((stat) => {
        console.log('Stats loaded:', stat)
        this.totalBadgesActive = stat.totalCardActive
        this.badges = stat.totalCard
        this.certificatControls = stat.totalRapport
        this.complianceRate = stat.ConformeRate
        this.trendMultiLine = stat.trendMultiLine
        this.trendChart = {
          ...this.trendChart,
          series: [
            {
              name: "Inspections",
              data: stat.trend.inspections
            }
          ],
          xaxis: {
            ...this.trendChart.xaxis,
            categories: this.formatDates(stat.trend.categories),
          }
        }
        this.vehicleTypeChart = {
          ...this.vehicleTypeChart,
          series: stat.vehicleTypes.series,
          labels: [...stat.vehicleTypes.labels, "Autres"]
        }
        this.statusChart = {
          ...this.statusChart,
          series: [
            {
              name: "Conformes",
              data: stat.status.conformes
            },
            {
              name: "Non conformes",
              data: stat.status.nonConformes
            }
          ],
          xaxis: {
            ...this.statusChart.xaxis,
            categories: this.formatDates(stat.status.categories)
          }
        }
        this.lineChart = {
          ...this.lineChart,
          series: stat.partners,
          xaxis: {
            ...this.lineChart.xaxis,
            categories: stat.categories
          }
        }
        this.inspectionSocieteChart = {
          ...this.inspectionSocieteChart,
          series: [{
            name: 'Nombre d\'inspections',
            data: stat.InspectionPerSocetite.series
          }],
          xaxis: {
            ...this.inspectionSocieteChart.xaxis,
            categories: stat.InspectionPerSocetite.labels,
          }
        }
        this.updateChartWithData(stat.trendMultiLine)
        // IMPORTANT: Ne PAS toucher aux données du tableau avec Option 3
        // Marquer les statistiques comme chargées
        this.statsDataLoaded = true;
        this.checkAllDataLoaded();
      })
    } else {
      this.dataService.getState(this.dateDebut, this.dateFin, this.selectedInspection).subscribe((stat) => {
        console.log('Stats loaded with inspection:', stat)
        this.totalBadgesActive = stat.totalCardActive
        this.badges = stat.totalCard
        this.certificatControls = stat.totalRapport
        this.complianceRate = stat.ConformeRate
        this.trendChart = {
          ...this.trendChart,
          series: [
            {
              name: "Inspections",
              data: stat.trend.inspections
            }
          ],
          xaxis: {
            ...this.trendChart.xaxis,
            categories: this.formatDates(stat.trend.categories),
          }
        }
        this.vehicleTypeChart = {
          ...this.vehicleTypeChart,
          series: stat.vehicleTypes.series,
          labels: [...stat.vehicleTypes.labels, "Autres"]
        }
        this.statusChart = {
          ...this.statusChart,
          series: [
            {
              name: "Conformes",
              data: stat.status.conformes
            },
            {
              name: "Non conformes",
              data: stat.status.nonConformes
            }
          ],
          xaxis: {
            ...this.statusChart.xaxis,
            categories: this.formatDates(stat.status.categories)
          }
        }
        this.lineChart = {
          ...this.lineChart,
          series: stat.partners,
          xaxis: {
            ...this.lineChart.xaxis,
            categories: stat.categories
          }
        }
        this.updateChartWithData(stat.trendMultiLine)
        // IMPORTANT: Ne PAS toucher aux données du tableau avec Option 3
        // Marquer les statistiques comme chargées
        this.statsDataLoaded = true;
        this.checkAllDataLoaded();
      })
    }

    // Option 3: Les filtres de recherche sont désactivés avec la pagination serveur
    // TODO: Implémenter la recherche côté serveur si nécessaire
    // Pour l'instant, ces subscriptions sont commentées car elles utilisent filteredInspections

    /* DÉSACTIVÉ AVEC OPTION 3 - Pagination serveur
    this.subscription = this.inputSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      map(searchText => {
        // Avec l'option 3, la recherche devrait se faire côté serveur
        // Pour l'instant, on filtre uniquement sur la page actuelle
        if (!searchText.trim()) return this.paginatedInspections;

        const lowerSearch = searchText.toString().toLowerCase();
        return this.paginatedInspections.filter((item: any) =>
          item.societe.toLowerCase().includes(lowerSearch) ||
          item.creationDate.toString().includes(lowerSearch) ||
          item.validite.toString().includes(lowerSearch) ||
          item.avisFavorable?.toString().includes(lowerSearch)
        );
      })
    ).subscribe(filtered => {
      // Note: Ceci filtre uniquement la page actuelle, pas toutes les données
      this.paginatedInspections = filtered;
    });

    this.dateSubscription = this.dateInputSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      map(dateText => {
        if (!dateText.trim()) {
          return this.paginatedInspections;
        }

        const dateToString = dateText.toString();
        return this.paginatedInspections.filter((item: any) =>
          item.creationDate.toString().includes(dateToString)
        );
      })
    ).subscribe(filtered => {
      this.paginatedInspections = filtered;
    });

    this.statusSubscription = this.statusSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      map(statut => {
        if (statut === '-1') {
          return this.paginatedInspections;
        }
        if (statut === 'conforme') {
          return this.paginatedInspections.filter(
            (item: any) => item.avisFavorable === true
          );
        }
        if (statut === 'non-conforme') {
          return this.paginatedInspections.filter(
            (item: any) => item.avisFavorable !== true
          );
        }
        return this.paginatedInspections;
      })
    ).subscribe(filtered => {
      this.paginatedInspections = filtered;
    });
    */

  }

  updateChartsWithFilteredData(filteredData: any[]): void {
    // Ici, vous devriez normalement regrouper et agréger les données filtrées
    // Pour cet exemple, nous allons simplement mettre à jour avec des données aléatoires

    const daysCount = 14; // Du 1er au 14 septembre
    const newConformes = Array(daysCount).fill(0).map(() => Math.floor(Math.random() * 20) + 30);
    const newNonConformes = Array(daysCount).fill(0).map(() => Math.floor(Math.random() * 10) + 5);
    const newTrend = Array(daysCount).fill(0).map(() => Math.floor(Math.random() * 15) + 45);

    this.statusChart.series = [
      { name: 'Conformes', data: newConformes },
      { name: 'Non conformes', data: newNonConformes }
    ];

    this.trendChart.series = [
      { name: 'Inspections', data: newTrend }
    ];

    // Forcer la mise à jour des graphiques
    this.statusChart = { ...this.statusChart };
    this.trendChart = { ...this.trendChart };
  }

  generateReportAction(certificatControlId: number) {
    this.store.dispatch(generateCertificatControl(certificatControlId))
  }

  downloadInspection(inspectionId: string): void {
    // Simuler le téléchargement d'une fiche d'inspection
    console.log(`Téléchargement de la fiche d'inspection: ${inspectionId}`);
    // Ici, vous implémenteriez la logique réelle de téléchargement
    alert(`Téléchargement de la fiche ${inspectionId}`);
  }

  // Ancienne méthode d'export (gardée pour compatibilité)
  exportToExcel(): void {
    this.exportCurrentPageToExcel();
  }

  // Nouvelle méthode : Exporter uniquement la page actuelle
  exportCurrentPageToExcel(): void {
    this.showExportDropdown = false;

    // Vérifier s'il y a des données à exporter
    if (this.paginatedInspections.length === 0) {
      alert('Aucune donnée à exporter sur cette page');
      return;
    }

    // Mapper les données de la page actuelle avec des colonnes formatées en français
    const mappedData = this.paginatedInspections.map((ctrl: any) => {
      return {
        'N° Ordre': ctrl.id,
        'Date Inspection': ctrl.creationDate,
        'Société': ctrl.societe,
        'Description': ctrl.description,
        'Site': ctrl.site,
        'Localisation': ctrl.localisationCertificationFait,
        'Statut': ctrl.avisFavorable ? 'Conforme' : 'Non conforme',
        'Validité': ctrl.validite, // Déjà formaté (1 MOIS, 2 MOIS, etc.)
        'Véhicule': ctrl.vehicule?.numeroAssurance || '',
        'Chauffeur': ctrl.chauffeur?.nom || '',
        'Inspecteur': ctrl.utilisateur?.nom || ''
      };
    });

    // 1. Convertir les données formatées en worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedData);

    // 2. Créer un workbook et ajouter le worksheet
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Inspections': worksheet },
      SheetNames: ['Inspections'],
    };

    // 3. Générer un buffer Excel
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 4. Sauvegarder le fichier
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const fileName = `export_page_${this.currentPage}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    saveAs(blob, fileName);
  }

  // Nouvelle méthode : Exporter toutes les données
  exportAllDataToExcel(): void {
    this.showExportDropdown = false;

    // Faire un appel API pour récupérer TOUTES les données
    this.dataService.getAllCertificatControlsForExport().subscribe(
      (response: any) => {
        // Gérer la structure paginée du backend
        let allData: any[] = [];

        if (response && response.content && Array.isArray(response.content)) {
          // Si c'est une réponse paginée
          allData = response.content;
        } else if (Array.isArray(response)) {
          // Si c'est directement un tableau
          allData = response;
        }

        if (allData.length === 0) {
          alert('Aucune donnée à exporter');
          return;
        }

        // Mapper les données avec les labels de validité
        const mappedData = allData.map((ctrl: any) => {
          const option = this.moisOptions.find(opt => opt.value === ctrl.validite);
          return {
            'N° Ordre': ctrl.id,
            'Date Inspection': ctrl.creationDate,
            'Société': ctrl.societe,
            'Description': ctrl.description,
            'Site': ctrl.site,
            'Localisation': ctrl.localisationCertificationFait,
            'Statut': ctrl.avisFavorable ? 'Conforme' : 'Non conforme',
            'Validité': option ? option.label : ctrl.validite,
            'Véhicule': ctrl.vehicule?.numeroAssurance || '',
            'Chauffeur': ctrl.chauffeur?.nom || '',
            'Inspecteur': ctrl.utilisateur?.nom || ''
          };
        });

        // 1. Convertir toutes les données en worksheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedData);

        // 2. Créer un workbook et ajouter le worksheet
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Inspections': worksheet },
          SheetNames: ['Inspections'],
        };

        // 3. Générer un buffer Excel
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // 4. Sauvegarder le fichier
        const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const fileName = `export_inspections_complet_${new Date().toISOString().slice(0, 10)}.xlsx`;
        saveAs(blob, fileName);

        console.log(`Export réussi: ${mappedData.length} lignes exportées`);
      },
      (error: any) => {
        console.error('Erreur lors de l\'export complet:', error);
        alert('Erreur lors de l\'export des données complètes');
      }
    );
  }

  // Méthode pour toggle le dropdown d'export
  toggleExportDropdown(): void {
    this.showExportDropdown = !this.showExportDropdown;
  }

  get startIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endIndex(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get visiblePages(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      console.log(`📄 Changement de page: ${this.currentPage} → ${page}`);
      this.currentPage = page;
      // NE PAS réinitialiser les flags lors de la pagination
      // Les données se mettront à jour via le subscribe du store
      this.loadCertificatControls(page - 1, this.itemsPerPage);
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      console.log(`⬅️ Page précédente: ${this.currentPage} → ${this.currentPage - 1}`);
      this.currentPage--;
      this.loadCertificatControls(this.currentPage - 1, this.itemsPerPage);
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      console.log(`➡️ Page suivante: ${this.currentPage} → ${this.currentPage + 1}`);
      this.currentPage++;
      this.loadCertificatControls(this.currentPage - 1, this.itemsPerPage);
    }
  }
}
